import { render, staticRenderFns } from "./PanelTe01.vue?vue&type=template&id=6d161976&scoped=true"
import script from "./PanelTe01.vue?vue&type=script&lang=js"
export * from "./PanelTe01.vue?vue&type=script&lang=js"
import style0 from "./PanelTe01.vue?vue&type=style&index=0&id=6d161976&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d161976",
  null
  
)

export default component.exports